import { Link } from "react-router-dom";

interface SectionTitleProps {
  icon: string;
  title: string;
  description?: string;
  moreHref?: string;
  moreLabel?: string;
}

export default function SectionTitle({
  icon,
  title,
  description,
  moreHref,
  moreLabel = "查看全部",
}: SectionTitleProps) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4">
      <div className="flex items-start gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-md bg-accent-500 text-lg text-background-50">
          <i className={icon}></i>
        </span>
        <div>
          <h2 className="text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            {title}
          </h2>
          {description ? (
            <p className="mt-1 text-sm text-foreground-600">{description}</p>
          ) : null}
        </div>
      </div>
      {moreHref ? (
        <Link
          to={moreHref}
          className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg"></i>
        </Link>
      ) : null}
    </div>
  );
}